import axios from "axios";
import hmacSHA512 from 'crypto-js/hmac-sha512';
import Base64 from 'crypto-js/enc-base64';
import { LogInCall, LogInShare } from "./StoreCall";
import { api1, x_accesskey1, SecretKey1 } from "./../configuracion";
//var CryptoJS = require("crypto-js");




var api = api1;//"https://api.izttra.com/morenamia-api-dev/";
//var api = "http://localhost"; 
var apigeneral = "";
var x_accesskey = x_accesskey1;//"1081592e5bcf4d20a3233e044a0171f4";
var SecretKey = SecretKey1; //"116971e670ad4dc6821dd3ea75d7f671";

export async function consumir_api(apis, json = {}, tipo = "post", bandera, isMultipart = false) {
  const dia_ac = new Date();
  let month = "" + (dia_ac.getMonth() + 1),
    day = "" + dia_ac.getDate(),
    year = dia_ac.getFullYear(),
    h = "" + dia_ac.getHours(),
    m = "" + dia_ac.getMinutes(),
    ss = "" + dia_ac.getSeconds();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;
  if (h.length < 2) h = "0" + h;
  if (m.length < 2) m = "0" + m;
  if (ss.length < 2) ss = "0" + ss;

  const dia_actual = [year, month, day].join("-");
  const hora_actual = [h, m, ss].join(":");
  const fecha = `${dia_actual} ${hora_actual}`;

  const token = Base64.stringify(hmacSHA512(fecha + x_accesskey + apis, SecretKey));

  try {
    let headers = {
      "content-type": isMultipart ? "multipart/form-data" : "application/json"
    };

    if (bandera === "login" || bandera === "recuperarPass") {
      headers["apikey"] = "7Fv9QmA2ZxP8RkT3dEJwYHc4N6L0bS5UeKpMVaBfD1XoCqGnhWtirOyIsu";
    }

    if (bandera !== "login" && bandera !== "recuperarPass") {
      const datos = localStorage.getItem("datosm");
      if (datos) headers["Authorization"] = `Bearer ${datos}`;
    }

    let consulta;

    if (tipo === "get") {
      consulta = await axios.get(api + apis, { headers, params: json });
    } else if (tipo === "delete") {
      consulta = await axios.delete(api + apis, { headers, data: json });
    } else if (tipo === "put") {
      consulta = await axios.put(api + apis, json, { headers });
    } else if (tipo === "postfile") {
      consulta = await axios.post(api + apis, json, {
        headers,
        responseType: "text",
        transformResponse: [(data) => data],
      });
    } else {
      consulta = await axios.post(api + apis, json, { headers });
    }
    const data = consulta?.data;
    if (tipo !== "postfile" && handleAuthCodes(data)) return data;
    return data;

  } catch (error) {
    const data = error?.response?.data;

    if (tipo === "postfile") {
      if (typeof data === "string") return data;
      if (data) return data;
      return -1;
    }

    if (data && handleAuthCodes(data)) return data;

    return -1;

  }
}

function handleAuthCodes(data) {
  const code = Number(data?.code);

  // Regla clave
  if (code === 2001 || code === 2002 || code === 2003) {
    logoutAndGoLogin();
    return true;
  }


  return false;
}

//////
function logoutAndGoLogin(message = "Tu sesión expiró. Inicia sesión nuevamente.") {
  try {
    sessionStorage.setItem("toast_after_login", message);
    localStorage.removeItem("datosm");
    localStorage.removeItem("share");
  } catch (e) { }

  if (window.location.pathname !== "/") window.location.href = "/";
}





function mensajeerrorconexion() {
  return "Error de conexión, revisa tu conexión a internet"
}


///////////////////////////////////  Login   //////////////////////////////////////////////////////////////

export async function validarlogin(email, pass) {

  var json = { "email": email, "password": pass }
  var resp = [];

  try {

    var datos = await consumir_api(apigeneral + "api/login", json, "post", "login")
    //console.log("Datos Generales --- ")

    //console.log(JSON.stringify(datos))
    if (datos === -1) {
      resp.push({
        code: 10,
        message: mensajeerrorconexion()
      })
    }

    else if (datos.code === 0) {
      var temporal = datos.data;

      resp.push({
        code: 0,
        data: ''
      })

      LogInCall(temporal.token);
      LogInShare(JSON.stringify(temporal.user));
    }
    else if (datos.code === 2) {
      resp.push({ code: 2, data: [], message: datos.message })
    }
    else {
      resp.push({ code: datos.code, data: [], message: datos.message })
    }


  } catch (error) {
    ////console.log("sin conexion");
    resp.push({
      code: 10,
      message: mensajeerrorconexion()
    })
  }
  return resp[0];
}

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export async function recuperarpass(email) {

  var json = { "email": email }
  var resp = [];

  try {

    var datos = await consumir_api(apigeneral + "api/catalogo/usuarios/recuperar-password", json, "post", "recuperarPass") 

    if (datos === -1) {
      //console.log("Datos Generales --- ")
      resp.push({
        code: 10,
        message: mensajeerrorconexion()
      })
    }

    else if (datos.code === 0) {
      var temporal = datos.data;

      resp.push({
        code: 0,
        data: temporal,
        message: datos.message
      })

    }
    else if (datos.code === 2) {
      resp.push({ code: 2, data: [], message: datos.message })
    }
    else {
      resp.push({ code: datos.code, data: [], message: datos.message })
    }


  } catch (error) {
    // console.log("sin conexion");
    resp.push({
      code: 10,
      message: mensajeerrorconexion()
    })
  }
  return resp[0];
}
/////////////////////////////////////////////////////////////////////////////////////////////////

export async function getVntas(json) {
  var resp = [];

  try {
    var datos = await consumir_api(apigeneral + "api/ventas/lista", json, "get");
    // //console.log(JSON.stringify(datos))

    if (datos === -1) {
      resp.push({
        code: 10,
        message: mensajeerrorconexion()
      })
    }

    else if (datos.code === 0) {
      var temporal = datos.data;
      //console.log(temporal.length)
      resp.push({
        code: 0,
        data: temporal
      })
    }
    else if (datos.code === 2) {
      resp.push({ code: 2, data: [], message: datos.message })
    }
    else {

      resp.push({ code: datos.code, data: [], message: datos.message })


    }
  } catch (error) {
    ////console.log("error de conexion");
    resp.push({
      code: 1000,
      message: "Error de conexión, revisa tu conexión a internet"
    })
  }
  return resp[0];
}
////////////////////////////////////////////////////////////////////////////////////////////////

/////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////

export async function apidesvincular(idsolicitudfactura, idticketpago) {


  var resp = [];

  try {

    var datos = await consumir_api(apigeneral + `api/desvinculacion/${idsolicitudfactura}`, { idticketpago }, "put", "")

    if (datos === -1) {
      //console.log("Datos Generales --- ")
      resp.push({
        code: 10,
        message: mensajeerrorconexion()
      })
    }

    else if (datos.code === 0) {
      var temporal = datos.data;

      resp.push({
        code: 0,
        data: temporal,
        message: datos.message
      })

    }
    else if (datos.code === 2) {
      resp.push({ code: 2, data: [], message: datos.message })
    }
    else {
      resp.push({ code: datos.code, data: [], message: datos.message })
    }


  } catch (error) {
    // console.log("sin conexion");
    resp.push({
      code: 10,
      message: mensajeerrorconexion()
    })
  }
  return resp[0];
}
/////////////////////////////////////////////////////////////////////////////////////////////////

export async function apiVincular(idsolicitudfactura, idticketpago) {


  var resp = [];

  try {

    var datos = await consumir_api(apigeneral + `api/vinculacion/${idsolicitudfactura}`, { idticketpago }, "put", "")

    if (datos === -1) {
      //console.log("Datos Generales --- ")
      resp.push({
        code: 10,
        message: mensajeerrorconexion()
      })
    }

    else if (datos.code === 0) {
      var temporal = datos.data;

      resp.push({
        code: 0,
        data: temporal,
        message: datos.message
      })

    }
    else if (datos.code === 2) {
      resp.push({ code: 2, data: [], message: datos.message })
    }
    else {
      resp.push({ code: datos.code, data: [], message: datos.message })
    }


  } catch (error) {
    // console.log("sin conexion");
    resp.push({
      code: 10,
      message: mensajeerrorconexion()
    })
  }
  return resp[0];
}
/////////////////////////////////////////////////////////////////////////////////////////////////

export async function solicitudDetalle(idsolicitudfactura) {
  var resp = [];

  try {
    var datos = await consumir_api(apigeneral + "api/solicitud/detalle/" + idsolicitudfactura, [], "get");
    // //console.log(JSON.stringify(datos))

    if (datos === -1) {
      resp.push({
        code: 10,
        message: mensajeerrorconexion()
      })
    }

    else if (datos.code === 0) {
      var temporal = datos.data;
      //console.log(temporal.length)
      resp.push({
        code: 0,
        data: temporal
      })
    }
    else if (datos.code === 2) {
      resp.push({ code: 2, data: [], message: datos.message })
    }
    else {

      resp.push({ code: datos.code, data: [], message: datos.message })


    }
  } catch (error) {
    ////console.log("error de conexion");
    resp.push({
      code: 1000,
      message: "Error de conexión, revisa tu conexión a internet"
    })
  }
  return resp[0];
}
/////////////////////////////////////////////////////////////////////////////////////////////////
export async function ventasListaNoVinculadas(idticket) {
  var resp = [];

  try {
    var datos = await consumir_api(apigeneral + "api/ventas/lista-no-vinculadas/" + idticket, [], "get");
    // //console.log(JSON.stringify(datos))

    if (datos === -1) {
      resp.push({
        code: 10,
        message: mensajeerrorconexion()
      })
    }

    else if (datos.code === 0) {
      var temporal = datos.data;
      //console.log(temporal.length)
      resp.push({
        code: 0,
        data: temporal
      })
    }
    else if (datos.code === 2) {
      resp.push({ code: 2, data: [], message: datos.message })
    }
    else {

      resp.push({ code: datos.code, data: [], message: datos.message })


    }
  } catch (error) {
    ////console.log("error de conexion");
    resp.push({
      code: 1000,
      message: "Error de conexión, revisa tu conexión a internet"
    })
  }
  return resp[0];
}
//////////////////////////////////////////////////////////////////////////////////////////////////

export async function getTipoCambio(json) {
  var resp = [];

  try {
    var datos = await consumir_api(apigeneral + "api/coleccion/obtener-tipo-cambio", json, "get");
    // //console.log(JSON.stringify(datos))

    if (datos === -1) {
      resp.push({
        code: 10,
        message: mensajeerrorconexion()
      })
    }

    else if (datos.code === 0) {
      var temporal = datos.data;
      //console.log(temporal.length)
      resp.push({
        code: 0,
        data: temporal
      })
    }
    else if (datos.code === 2) {
      resp.push({ code: 2, data: [], message: datos.message })
    }
    else {

      resp.push({ code: datos.code, data: [], message: datos.message })


    }
  } catch (error) {
    ////console.log("error de conexion");
    resp.push({
      code: 1000,
      message: "Error de conexión, revisa tu conexión a internet"
    })
  }
  return resp[0];
}
//////////////////////////////////////////////////////////////////////////////////////////////////

export async function getListSat() {
  var resp = [];

  try {
    var datos = await consumir_api(apigeneral + "api/coleccion/catalogos-sat", [], "get");
    // //console.log(JSON.stringify(datos))

    if (datos === -1) {
      resp.push({
        code: 10,
        message: mensajeerrorconexion()
      })
    }

    else if (datos.code === 0) {
      var temporal = datos.data;
      //console.log(temporal.length)
      resp.push({
        code: 0,
        data: temporal
      })
    }
    else if (datos.code === 2) {
      resp.push({ code: 2, data: [], message: datos.message })
    }
    else {

      resp.push({ code: datos.code, data: [], message: datos.message })


    }
  } catch (error) {
    ////console.log("error de conexion");
    resp.push({
      code: 1000,
      message: "Error de conexión, revisa tu conexión a internet"
    })
  }
  return resp[0];
}

//////////////////////////////////////////////////////////////////////////////////////////////////

export async function getDetallesVentas(json) {
  var resp = [];

  try {
    var datos = await consumir_api(apigeneral + "api/ventas/detalle/" + json, [], "get");
    // //console.log(JSON.stringify(datos))

    if (datos === -1) {
      resp.push({
        code: 10,
        message: mensajeerrorconexion()
      })
    }

    else if (datos.code === 0) {
      var temporal = datos.data;
      //console.log(temporal.length)
      resp.push({
        code: 0,
        data: temporal
      })
    }
    else if (datos.code === 2) {
      resp.push({ code: 2, data: [], message: datos.message })
    }
    else {

      resp.push({ code: datos.code, data: [], message: datos.message })


    }
  } catch (error) {
    ////console.log("error de conexion");
    resp.push({
      code: 1000,
      message: "Error de conexión, revisa tu conexión a internet"
    })
  }
  return resp[0];
}
//////////////////////////////////////////////////////////////////////////////////////////////////

export async function getListaProductos(json) {
  var resp = [];

  try {
    var datos = await consumir_api(apigeneral + "api/coleccion/catalogo-productos", json, "get");
    // //console.log(JSON.stringify(datos))

    if (datos === -1) {
      resp.push({
        code: 10,
        message: mensajeerrorconexion()
      })
    }

    else if (datos.code === 0) {
      var temporal = datos.data;
      //console.log(temporal.length)
      resp.push({
        code: 0,
        data: temporal
      })
    }
    else if (datos.code === 2) {
      resp.push({ code: 2, data: [], message: datos.message })
    }
    else {

      resp.push({ code: datos.code, data: [], message: datos.message })


    }
  } catch (error) {
    ////console.log("error de conexion");
    resp.push({
      code: 1000,
      message: "Error de conexión, revisa tu conexión a internet"
    })
  }
  return resp[0];
}
//////////////////////////////////////////////////////////////////////////////////////////////////

export async function agregarNuevo(json) {


  var resp = [];

  try {

    var datos = await consumir_api(apigeneral + "api/coleccion/productos", json, "post", "")

    if (datos === -1) {
      //console.log("Datos Generales --- ")
      resp.push({
        code: 10,
        message: mensajeerrorconexion()
      })
    }

    else if (datos.code === 0) {
      var temporal = datos.data;

      resp.push({
        code: 0,
        data: temporal,
        message: datos.message
      })

    }
    else if (datos.code === 2) {
      resp.push({ code: 2, data: [], message: datos.message })
    }
    else {
      resp.push({ code: datos.code, data: [], message: datos.message })
    }


  } catch (error) {
    // console.log("sin conexion");
    resp.push({
      code: 10,
      message: mensajeerrorconexion()
    })
  }
  return resp[0];
}
/////////////////////////////////////////////////////////////////////////////////////////////////
export async function guardarTipoCAmbio(json) {


  var resp = [];

  try {

    var datos = await consumir_api(apigeneral + "api/coleccion/asignar-tipo-cambio", json, "post", "")

    if (datos === -1) {
      //console.log("Datos Generales --- ")
      resp.push({
        code: 10,
        message: mensajeerrorconexion()
      })
    }

    else if (datos.code === 0) {
      var temporal = datos.data;

      resp.push({
        code: 0,
        data: temporal,
        message: datos.message
      })

    }
    else if (datos.code === 2) {
      resp.push({ code: 2, data: [], message: datos.message })
    }
    else {
      resp.push({ code: datos.code, data: [], message: datos.message })
    }


  } catch (error) {
    // console.log("sin conexion");
    resp.push({
      code: 10,
      message: mensajeerrorconexion()
    })
  }
  return resp[0];
}

/////////////////////////////////////////////////////////////////////////////////////////////////
export async function guardarSolicitud(json) {


  var resp = [];

  try {

    var datos = await consumir_api(apigeneral + "api/ventas/solicitud-guardar", json, "post", "")

    if (datos === -1) {
      //console.log("Datos Generales --- ")
      resp.push({
        code: 10,
        message: mensajeerrorconexion()
      })
    }

    else if (datos.code === 0) {
      var temporal = datos.data;

      resp.push({
        code: 0,
        data: temporal,
        message: datos.message
      })

    }
    else if (datos.code === 2) {
      resp.push({ code: 2, data: [], message: datos.message })
    }
    else {
      resp.push({ code: datos.code, data: [], message: datos.message })
    }


  } catch (error) {
    // console.log("sin conexion");
    resp.push({
      code: 10,
      message: mensajeerrorconexion()
    })
  }
  return resp[0];
}
////////////////////////  descargar /////////////////////////////////////////////////////////////////////////
export async function descargarFactura(json) {
  try {
    const datos = await consumir_api(apigeneral + "api/factura/generar", json, "postfile", "");

    if (datos === -1) {
      return {
        code: 10,
        data: "",
        message: mensajeerrorconexion()
      };
    }

    // Si ya vino objeto JSON, respétalo
    if (typeof datos === "object" && datos !== null) {
      return {
        code: Number(datos.code ?? 99),
        data: datos.data ?? "",
        message: datos.message || "Respuesta inválida del servidor"
      };
    }

    const raw = String(datos || "").trim();

    if (!raw) {
      return {
        code: 99,
        data: "",
        message: "No se recibió contenido XML"
      };
    }

    // Si vino JSON serializado como texto, parsearlo
    if (raw.startsWith("{") || raw.startsWith("[")) {
      try {
        const parsed = JSON.parse(raw);
        return {
          code: Number(parsed.code ?? 99),
          data: parsed.data ?? "",
          message: parsed.message || "Respuesta inválida del servidor"
        };
      } catch (e) {
        return {
          code: 99,
          data: "",
          message: "La respuesta no es un XML válido ni un JSON válido"
        };
      }
    }

    // Validar que realmente parezca XML
    const pareceXml =
      raw.startsWith("<?xml") ||
      raw.startsWith("<cfdi:") ||
      raw.startsWith("<Comprobante") ||
      raw.startsWith("<");

    if (!pareceXml) {
      return {
        code: 99,
        data: "",
        message: "La respuesta no contiene un XML válido"
      };
    }

    return {
      code: 0,
      data: raw,
      message: "XML generado correctamente"
    };
  } catch (error) {
    return {
      code: 10,
      data: "",
      message: mensajeerrorconexion()
    };
  }
}
/////////////////////////////////////////////////////////////////////////////////////////////////

export async function editarProducto(idproducto, json) {


  var resp = [];

  try {

    var datos = await consumir_api(apigeneral + "api/coleccion/productos/" + idproducto, json, "put", "")

    if (datos === -1) {
      //console.log("Datos Generales --- ")
      resp.push({
        code: 10,
        message: mensajeerrorconexion()
      })
    }

    else if (datos.code === 0) {
      var temporal = datos.data;

      resp.push({
        code: 0,
        data: temporal,
        message: datos.message
      })

    }
    else if (datos.code === 2) {
      resp.push({ code: 2, data: [], message: datos.message })
    }
    else {
      resp.push({ code: datos.code, data: [], message: datos.message })
    }


  } catch (error) {
    // console.log("sin conexion");
    resp.push({
      code: 10,
      message: mensajeerrorconexion()
    })
  }
  return resp[0];
}
/////////// Nacionalidad    //////////////////////////////////////////////////////////////////////////////////////
export async function getListaNacionalidad(json) {
  var resp = [];

  try {
    var datos = await consumir_api(apigeneral + "api/coleccion/nacionalidades", json, "get");
    // //console.log(JSON.stringify(datos))

    if (datos === -1) {
      resp.push({
        code: 10,
        message: mensajeerrorconexion()
      })
    }

    else if (datos.code === 0) {
      var temporal = datos.data;
      //console.log(temporal.length)
      resp.push({
        code: 0,
        data: temporal
      })
    }
    else if (datos.code === 2) {
      resp.push({ code: 2, data: [], message: datos.message })
    }
    else {

      resp.push({ code: datos.code, data: [], message: datos.message })


    }
  } catch (error) {
    ////console.log("error de conexion");
    resp.push({
      code: 1000,
      message: "Error de conexión, revisa tu conexión a internet"
    })
  }
  return resp[0];
}
/////// guardar nacionlidad
/////////////////////////////////////////////////////////////////////////////////////////////////
export async function guardarNacionalidad(json) {


  var resp = [];

  try {

    var datos = await consumir_api(apigeneral + "api/coleccion/nacionalidades", json, "post", "")

    if (datos === -1) {
      //console.log("Datos Generales --- ")
      resp.push({
        code: 10,
        message: mensajeerrorconexion()
      })
    }

    else if (datos.code === 0) {
      var temporal = datos.data;

      resp.push({
        code: 0,
        data: temporal,
        message: datos.message
      })

    }
    else if (datos.code === 2) {
      resp.push({ code: 2, data: [], message: datos.message })
    }
    else {
      resp.push({ code: datos.code, data: [], message: datos.message })
    }


  } catch (error) {
    // console.log("sin conexion");
    resp.push({
      code: 10,
      message: mensajeerrorconexion()
    })
  }
  return resp[0];
}
/////// Actualizar nacionlidad

export async function editarNacionalidad(idnacionalidad, json) {

  var resp = [];
  try {

    var datos = await consumir_api(apigeneral + "api/coleccion/nacionalidades/" + idnacionalidad, json, "put", "")

    if (datos === -1) {
      //console.log("Datos Generales --- ")
      resp.push({
        code: 10,
        message: mensajeerrorconexion()
      })
    }

    else if (datos.code === 0) {
      var temporal = datos.data;

      resp.push({
        code: 0,
        data: temporal,
        message: datos.message
      })

    }
    else if (datos.code === 2) {
      resp.push({ code: 2, data: [], message: datos.message })
    }
    else {
      resp.push({ code: datos.code, data: [], message: datos.message })
    }


  } catch (error) {
    // console.log("sin conexion");
    resp.push({
      code: 10,
      message: mensajeerrorconexion()
    })
  }
  return resp[0];
}

/////////// Tipo User   //////////////////////////////////////////////////////////////////////////////////////
export async function getlistaTiposUser(json) {
  var resp = [];

  try {
    var datos = await consumir_api(apigeneral + "api/catalogo/tipo-usuario", json, "get");
    // //console.log(JSON.stringify(datos))

    if (datos === -1) {
      resp.push({
        code: 10,
        message: mensajeerrorconexion()
      })
    }

    else if (datos.code === 0) {
      var temporal = datos.data;
      //console.log(temporal.length)
      resp.push({
        code: 0,
        data: temporal
      })
    }
    else if (datos.code === 2) {
      resp.push({ code: 2, data: [], message: datos.message })
    }
    else {

      resp.push({ code: datos.code, data: [], message: datos.message })


    }
  } catch (error) {
    ////console.log("error de conexion");
    resp.push({
      code: 1000,
      message: "Error de conexión, revisa tu conexión a internet"
    })
  }
  return resp[0];
}

export async function editarVentasAfiliacion(idticket, json) {

  var resp = [];
  try {

    var datos = await consumir_api(apigeneral + "api/ventas/afiliacion/" + idticket, json, "put", "")

    if (datos === -1) {
      //console.log("Datos Generales --- ")
      resp.push({
        code: 10,
        message: mensajeerrorconexion()
      })
    }

    else if (datos.code === 0) {
      var temporal = datos.data;

      resp.push({
        code: 0,
        data: temporal,
        message: datos.message
      })

    }
    else if (datos.code === 2) {
      resp.push({ code: 2, data: [], message: datos.message })
    }
    else {
      resp.push({ code: datos.code, data: [], message: datos.message })
    }


  } catch (error) {
    // console.log("sin conexion");
    resp.push({
      code: 10,
      message: mensajeerrorconexion()
    })
  }
  return resp[0];
}
////////////////////////////////////////////////////////////////
export async function cancelarFactura(folio) {

  var resp = [];
  try {

    var datos = await consumir_api(apigeneral + "api/factura/cancelar/" + folio, {}, "put", "")

    if (datos === -1) {
      //console.log("Datos Generales --- ")
      resp.push({
        code: 10,
        message: mensajeerrorconexion()
      })
    }

    else if (datos.code === 0) {
      var temporal = datos.data;

      resp.push({
        code: 0,
        data: temporal,
        message: datos.message
      })

    }
    else if (datos.code === 2) {
      resp.push({ code: 2, data: [], message: datos.message })
    }
    else {
      resp.push({ code: datos.code, data: [], message: datos.message })
    }


  } catch (error) {
    // console.log("sin conexion");
    resp.push({
      code: 10,
      message: mensajeerrorconexion()
    })
  }
  return resp[0];
}
/////////// Afiliaciones   //////////////////////////////////////////////////////////////////////////////////////
export async function getListaAfiliacion(json) {
  var resp = [];

  try {
    var datos = await consumir_api(apigeneral + "api/coleccion/afiliaciones", json, "get");
    // //console.log(JSON.stringify(datos))

    if (datos === -1) {
      resp.push({
        code: 10,
        message: mensajeerrorconexion()
      })
    }

    else if (datos.code === 0) {
      var temporal = datos.data;
      //console.log(temporal.length)
      resp.push({
        code: 0,
        data: temporal
      })
    }
    else if (datos.code === 2) {
      resp.push({ code: 2, data: [], message: datos.message })
    }
    else {

      resp.push({ code: datos.code, data: [], message: datos.message })


    }
  } catch (error) {
    ////console.log("error de conexion");
    resp.push({
      code: 1000,
      message: "Error de conexión, revisa tu conexión a internet"
    })
  }
  return resp[0];
}
//////////////////////////////////////////////////////////////////////////////////////////////////

export async function agregarAfiliacion(json) {


  var resp = [];

  try {

    var datos = await consumir_api(apigeneral + "api/coleccion/afiliaciones", json, "post", "")

    if (datos === -1) {
      //console.log("Datos Generales --- ")
      resp.push({
        code: 10,
        message: mensajeerrorconexion()
      })
    }

    else if (datos.code === 0) {
      var temporal = datos.data;

      resp.push({
        code: 0,
        data: temporal,
        message: datos.message
      })

    }
    else if (datos.code === 2) {
      resp.push({ code: 2, data: [], message: datos.message })
    }
    else {
      resp.push({ code: datos.code, data: [], message: datos.message })
    }


  } catch (error) {
    // console.log("sin conexion");
    resp.push({
      code: 10,
      message: mensajeerrorconexion()
    })
  }
  return resp[0];
}
/////////////////////////////////////////////////////////////////////////////////////////////////

export async function editarAfiliacion(json, idproducto) {

  var resp = [];
  try {

    var datos = await consumir_api(apigeneral + "api/coleccion/afiliaciones/" + idproducto, json, "put", "")

    if (datos === -1) {
      //console.log("Datos Generales --- ")
      resp.push({
        code: 10,
        message: mensajeerrorconexion()
      })
    }

    else if (datos.code === 0) {
      var temporal = datos.data;

      resp.push({
        code: 0,
        data: temporal,
        message: datos.message
      })

    }
    else if (datos.code === 2) {
      resp.push({ code: 2, data: [], message: datos.message })
    }
    else {
      resp.push({ code: datos.code, data: [], message: datos.message })
    }


  } catch (error) {
    // console.log("sin conexion");
    resp.push({
      code: 10,
      message: mensajeerrorconexion()
    })
  }
  return resp[0];
}
/////////////////////////////////////////////////////////////////////////////////////////////////

/////////// Monedas  /////////////////////////////////////////////////////////////////////////////////////
export async function getListaMoneda(json) {
  var resp = [];

  try {
    var datos = await consumir_api(apigeneral + "api/coleccion/monedas", json, "get");
    // //console.log(JSON.stringify(datos))

    if (datos === -1) {
      resp.push({
        code: 10,
        message: mensajeerrorconexion()
      })
    }

    else if (datos.code === 0) {
      var temporal = datos.data;
      //console.log(temporal.length)
      resp.push({
        code: 0,
        data: temporal
      })
    }
    else if (datos.code === 2) {
      resp.push({ code: 2, data: [], message: datos.message })
    }
    else {

      resp.push({ code: datos.code, data: [], message: datos.message })


    }
  } catch (error) {
    ////console.log("error de conexion");
    resp.push({
      code: 1000,
      message: "Error de conexión, revisa tu conexión a internet"
    })
  }
  return resp[0];
}
/////////// Usuarios  //////////////////////////////////////////////////////////////////////////////////////
export async function getListaUsuarios(json) {
  var resp = [];

  try {
    var datos = await consumir_api(apigeneral + "api/catalogo/usuarios", json, "get");
    // //console.log(JSON.stringify(datos))

    if (datos === -1) {
      resp.push({
        code: 10,
        message: mensajeerrorconexion()
      })
    }

    else if (datos.code === 0) {
      var temporal = datos.data;
      //console.log(temporal.length)
      resp.push({
        code: 0,
        data: temporal
      })
    }
    else if (datos.code === 2) {
      resp.push({ code: 2, data: [], message: datos.message })
    }
    else {

      resp.push({ code: datos.code, data: [], message: datos.message })


    }
  } catch (error) {
    ////console.log("error de conexion");
    resp.push({
      code: 1000,
      message: "Error de conexión, revisa tu conexión a internet"
    })
  }
  return resp[0];
}
///////////  Solicitudes  ///////////////////////////////////////////////////////////////////////////////////////////////
export async function getListaSolicitud(json) {
  var resp = [];

  try {
    var datos = await consumir_api(apigeneral + "api/solicitud/lista", json, "get");
    // //console.log(JSON.stringify(datos))

    if (datos === -1) {
      resp.push({
        code: 10,
        message: mensajeerrorconexion()
      })
    }

    else if (datos.code === 0) {
      var temporal = datos.data;
      //console.log(temporal.length)
      resp.push({
        code: 0,
        data: temporal
      })
    }
    else if (datos.code === 2) {
      resp.push({ code: 2, data: [], message: datos.message })
    }
    else {

      resp.push({ code: datos.code, data: [], message: datos.message })


    }
  } catch (error) {
    ////console.log("error de conexion");
    resp.push({
      code: 1000,
      message: "Error de conexión, revisa tu conexión a internet"
    })
  }
  return resp[0];
}
///////////  facturacion  //////////////////////////////////////////////////////////////////////////////////
export async function getFacturacion(json) {
  var resp = [];

  try {
    var datos = await consumir_api(apigeneral + "api/factura/lista", json, "get");
    // //console.log(JSON.stringify(datos))

    if (datos === -1) {
      resp.push({
        code: 10,
        message: mensajeerrorconexion()
      })
    }

    else if (datos.code === 0) {
      var temporal = datos.data;
      //console.log(temporal.length)
      resp.push({
        code: 0,
        data: temporal
      })
    }
    else if (datos.code === 2) {
      resp.push({ code: 2, data: [], message: datos.message })
    }
    else {

      resp.push({ code: datos.code, data: [], message: datos.message })


    }
  } catch (error) {
    ////console.log("error de conexion");
    resp.push({
      code: 1000,
      message: "Error de conexión, revisa tu conexión a internet"
    })
  }
  return resp[0];
}

/////////////////////////////////////////////////////////////////////////////////////

export async function getFacturacionDetalles(idfactura) {
  var resp = [];

  try {
    var datos = await consumir_api(apigeneral + "api/factura/detalle/" + idfactura, [], "get");
    // //console.log(JSON.stringify(datos))

    if (datos === -1) {
      resp.push({
        code: 10,
        message: mensajeerrorconexion()
      })
    }

    else if (datos.code === 0) {
      var temporal = datos.data;
      //console.log(temporal.length)
      resp.push({
        code: 0,
        data: temporal
      })
    }
    else if (datos.code === 2) {
      resp.push({ code: 2, data: [], message: datos.message })
    }
    else {

      resp.push({ code: datos.code, data: [], message: datos.message })


    }
  } catch (error) {
    ////console.log("error de conexion");
    resp.push({
      code: 1000,
      message: "Error de conexión, revisa tu conexión a internet"
    })
  }
  return resp[0];
}
//////////////////////////////////////////////////////////////////////////////////////////////////

export async function guardarFacturaPublica(json) {


  var resp = [];

  try {

    var datos = await consumir_api(apigeneral + "api/facturapublica/generar-factura", json, "post", "")

    if (datos === -1) {
      //console.log("Datos Generales --- ")
      resp.push({
        code: 10,
        message: mensajeerrorconexion()
      })
    }

    else if (datos.code === 0) {
      var temporal = datos.data;

      resp.push({
        code: 0,
        data: temporal,
        message: datos.message
      })

    }
    else if (datos.code === 2) {
      resp.push({ code: 2, data: [], message: datos.message })
    }
    else {
      resp.push({ code: datos.code, data: [], message: datos.message })
    }


  } catch (error) {
    // console.log("sin conexion");
    resp.push({
      code: 10,
      message: mensajeerrorconexion()
    })
  }
  return resp[0];
}
/////////////////////////////////////////////////////////////////////////////////////
export async function cancelarFacturaPublica(json) {


  var resp = [];

  try {

    var datos = await consumir_api(apigeneral + "api/factura/cancelar", json, "post", "")

    if (datos === -1) {
      //console.log("Datos Generales --- ")
      resp.push({
        code: 10,
        message: mensajeerrorconexion()
      })
    }

    else if (datos.code === 0) {
      var temporal = datos.data;

      resp.push({
        code: 0,
        data: temporal,
        message: datos.message
      })

    }
    else if (datos.code === 2) {
      resp.push({ code: 2, data: [], message: datos.message })
    }
    else {
      resp.push({ code: datos.code, data: [], message: datos.message })
    }


  } catch (error) {
    // console.log("sin conexion");
    resp.push({
      code: 10,
      message: mensajeerrorconexion()
    })
  }
  return resp[0];
}


/////////////////////////////////////////////////////////////////////////////////////
export async function guardarNotaCreditoGeneral(json) {


  var resp = [];

  try {

    var datos = await consumir_api(apigeneral + "api/factura/generar-nota-credito-general", json, "post", "")

    if (datos === -1) {
      //console.log("Datos Generales --- ")
      resp.push({
        code: 10,
        message: mensajeerrorconexion()
      })
    }

    else if (datos.code === 0) {
      var temporal = datos.data;

      resp.push({
        code: 0,
        data: temporal,
        message: datos.message
      })

    }
    else if (datos.code === 2) {
      resp.push({ code: 2, data: [], message: datos.message })
    }
    else {
      resp.push({ code: datos.code, data: [], message: datos.message })
    }


  } catch (error) {
    // console.log("sin conexion");
    resp.push({
      code: 10,
      message: mensajeerrorconexion()
    })
  }
  return resp[0];
}

/////////////////////////////////////////////////////////////////////////////////////
export async function guardarNotaCredito(json) {


  var resp = [];

  try {

    var datos = await consumir_api(apigeneral + "api/factura/generar-nota-credito", json, "post", "")

    if (datos === -1) {
      //console.log("Datos Generales --- ")
      resp.push({
        code: 10,
        message: mensajeerrorconexion()
      })
    }

    else if (datos.code === 0) {
      var temporal = datos.data;

      resp.push({
        code: 0,
        data: temporal,
        message: datos.message
      })

    }
    else if (datos.code === 2) {
      resp.push({ code: 2, data: [], message: datos.message })
    }
    else {
      resp.push({ code: datos.code, data: [], message: datos.message })
    }


  } catch (error) {
    // console.log("sin conexion");
    resp.push({
      code: 10,
      message: mensajeerrorconexion()
    })
  }
  return resp[0];
}
/////////////////////////////////////////////////////////////////////////////////////

export async function getFacturaPublica(json) {
  var resp = [];

  try {
    var datos = await consumir_api(apigeneral + "api/facturapublica/afiliaciones-pendientes", json, "get");

    if (datos === -1) {
      resp.push({
        code: 10,
        message: mensajeerrorconexion()
      })
    }

    else if (datos.code === 0) {
      var temporal = datos.data;
      //console.log(temporal.length)
      resp.push({
        code: 0,
        data: temporal
      })
    }
    else if (datos.code === 2) {
      resp.push({ code: 2, data: [], message: datos.message })
    }
    else {

      resp.push({ code: datos.code, data: [], message: datos.message })


    }
  } catch (error) {
    ////console.log("error de conexion");
    resp.push({
      code: 1000,
      message: "Error de conexión, revisa tu conexión a internet"
    })
  }
  return resp[0];
}
/////////////////// detalles ventas  //////////////////////////////////////////////////////////////////

export async function getDetallesFacturaPublica(json) {


  var resp = [];
  try {

    var datos = await consumir_api(apigeneral + "api/facturapublica/afiliacion-detalles", json, "post", "")

    if (datos === -1) {
      //console.log("Datos Generales --- ")
      resp.push({
        code: 10,
        message: mensajeerrorconexion()
      })
    }

    else if (datos.code === 0) {
      var temporal = datos.data;

      resp.push({
        code: 0,
        data: temporal,
        message: datos.message
      })

    }
    else if (datos.code === 2) {
      resp.push({ code: 2, data: [], message: datos.message })
    }
    else {
      resp.push({ code: datos.code, data: [], message: datos.message })
    }


  } catch (error) {
    // console.log("sin conexion");
    resp.push({
      code: 10,
      message: mensajeerrorconexion()
    })
  }
  return resp[0];
}


/////////////////////////////////////////////////////////////////////////////////////

///////////  locaciones con estatus 1  //////////////////////////////////////////////////////////////////////////////////
export async function getListaLocaciones(json) {
  var resp = [];

  try {
    var datos = await consumir_api(apigeneral + "api/coleccion/catalogo-locaciones", json, "get");
    // //console.log(JSON.stringify(datos))

    if (datos === -1) {
      resp.push({
        code: 10,
        message: mensajeerrorconexion()
      })
    }

    else if (datos.code === 0) {
      var temporal = datos.data;
      //console.log(temporal.length)
      resp.push({
        code: 0,
        data: temporal
      })
    }
    else if (datos.code === 2) {
      resp.push({ code: 2, data: [], message: datos.message })
    }
    else {

      resp.push({ code: datos.code, data: [], message: datos.message })


    }
  } catch (error) {
    ////console.log("error de conexion");
    resp.push({
      code: 1000,
      message: "Error de conexión, revisa tu conexión a internet"
    })
  }
  return resp[0];
}

///////////  locaciones Lista Generales  ////////////////////////////////////////////////////////////////////////////////
export async function getListaGeneralLocaciones(json) {
  var resp = [];

  try {
    var datos = await consumir_api(apigeneral + "api/coleccion/locaciones", json, "get");
    // //console.log(JSON.stringify(datos))

    if (datos === -1) {
      resp.push({
        code: 10,
        message: mensajeerrorconexion()
      })
    }

    else if (datos.code === 0) {
      var temporal = datos.data;
      //console.log(temporal.length)
      resp.push({
        code: 0,
        data: temporal
      })
    }
    else if (datos.code === 2) {
      resp.push({ code: 2, data: [], message: datos.message })
    }
    else {

      resp.push({ code: datos.code, data: [], message: datos.message })


    }
  } catch (error) {
    ////console.log("error de conexion");
    resp.push({
      code: 1000,
      message: "Error de conexión, revisa tu conexión a internet"
    })
  }
  return resp[0];
}
///////////  Editar locaciones   //////////////////////////////////////////////////////////////////////////////////

export async function editarEstatusLocacion(idlocacion, idestatus) {
  var json = { "idestatus": idestatus }

  var resp = [];
  try {

    var datos = await consumir_api(apigeneral + "api/coleccion/locaciones/" + idlocacion, json, "put", "")

    if (datos === -1) {
      //console.log("Datos Generales --- ")
      resp.push({
        code: 10,
        message: mensajeerrorconexion()
      })
    }

    else if (datos.code === 0) {
      var temporal = datos.data;

      resp.push({
        code: 0,
        data: temporal,
        message: datos.message
      })

    }
    else if (datos.code === 2) {
      resp.push({ code: 2, data: [], message: datos.message })
    }
    else {
      resp.push({ code: datos.code, data: [], message: datos.message })
    }


  } catch (error) {
    // console.log("sin conexion");
    resp.push({
      code: 10,
      message: mensajeerrorconexion()
    })
  }
  return resp[0];
}


///////////  Agregar Solicitud /////////////////////////////////////////////////////////////////////////////
export async function agregarSolicitud(json) {


  var resp = [];
  try {

    var datos = await consumir_api(apigeneral + "api/solicitud/nueva", json, "post", "")

    if (datos === -1) {
      //console.log("Datos Generales --- ")
      resp.push({
        code: 10,
        message: mensajeerrorconexion()
      })
    }

    else if (datos.code === 0) {
      var temporal = datos.data;

      resp.push({
        code: 0,
        data: temporal,
        message: datos.message
      })

    }
    else if (datos.code === 2) {
      resp.push({ code: 2, data: [], message: datos.message })
    }
    else {
      resp.push({ code: datos.code, data: [], message: datos.message })
    }


  } catch (error) {
    // console.log("sin conexion");
    resp.push({
      code: 10,
      message: mensajeerrorconexion()
    })
  }
  return resp[0];
}
/////////////////////////////////////////////////////////////////////////////////////////////////
export async function editarSolicitud(idproducto, json) {
  //idproducto = "idsolicitudfactura:"+idproducto;

  var resp = [];
  try {

    var datos = await consumir_api(apigeneral + "api/solicitud/editar/" + idproducto, json, "put", "")

    if (datos === -1) {
      //console.log("Datos Generales --- ")
      resp.push({
        code: 10,
        message: mensajeerrorconexion()
      })
    }

    else if (datos.code === 0) {
      var temporal = datos.data;

      resp.push({
        code: 0,
        data: temporal,
        message: datos.message
      })

    }
    else if (datos.code === 2) {
      resp.push({ code: 2, data: [], message: datos.message })
    }
    else {
      resp.push({ code: datos.code, data: [], message: datos.message })
    }


  } catch (error) {
    // console.log("sin conexion");
    resp.push({
      code: 10,
      message: mensajeerrorconexion()
    })
  }
  return resp[0];
}
/////////////////////////////////////////////////////////////////////////////////////////////////

export async function actualizarVentas(idticketpago, json) {
  //idproducto = "idsolicitudfactura:"+idproducto;

  var resp = [];
  try {

    var datos = await consumir_api(apigeneral + "api/ventas/editar/" + idticketpago, json, "put", "")

    if (datos === -1) {
      //console.log("Datos Generales --- ")
      resp.push({
        code: 10,
        message: mensajeerrorconexion()
      })
    }

    else if (datos.code === 0) {
      var temporal = datos.data;

      resp.push({
        code: 0,
        data: temporal,
        message: datos.message
      })

    }
    else if (datos.code === 2) {
      resp.push({ code: 2, data: [], message: datos.message })
    }
    else {
      resp.push({ code: datos.code, data: [], message: datos.message })
    }


  } catch (error) {
    // console.log("sin conexion");
    resp.push({
      code: 10,
      message: mensajeerrorconexion()
    })
  }
  return resp[0];
}
//////////////////////////////////////////////////////////////////////////////////////////////////

export async function descargarFacturaxml(folio) {
  try {
    const datos = await consumir_api(
      apigeneral + "api/factura/xml",
      { folio },
      "postfile",
      ""
    );

    if (datos === -1) {
      return {
        code: 10,
        data: "",
        message: mensajeerrorconexion()
      };
    }

    if (typeof datos === "object" && datos !== null) {
      return {
        code: Number(datos.code ?? 99),
        data: datos.data ?? "",
        message: datos.message || "Respuesta inválida del servidor"
      };
    }

    const raw = String(datos || "").trim();

    if (!raw) {
      return {
        code: 99,
        data: "",
        message: "No se recibió contenido XML"
      };
    }

    if (raw.startsWith("{") || raw.startsWith("[")) {
      try {
        const parsed = JSON.parse(raw);
        return {
          code: Number(parsed.code ?? 99),
          data: parsed.data ?? "",
          message: parsed.message || "Respuesta inválida del servidor"
        };
      } catch (e) {
        return {
          code: 99,
          data: "",
          message: "La respuesta no es un XML válido ni un JSON válido"
        };
      }
    }

    const pareceXml =
      raw.startsWith("<?xml") ||
      raw.startsWith("<cfdi:") ||
      raw.startsWith("<Comprobante") ||
      raw.startsWith("<");

    if (!pareceXml) {
      return {
        code: 99,
        data: "",
        message: "La respuesta no contiene un XML válido"
      };
    }

    return {
      code: 0,
      data: raw,
      message: "XML generado correctamente"
    };
  } catch (error) {
    return {
      code: 10,
      data: "",
      message: mensajeerrorconexion()
    };
  }
}


export async function descargarFacturapdf(folio) {
  try {
    const datos = await consumir_api(
      apigeneral + "api/factura/pdf",
      { folio },
      "postfile",
      ""
    );

    if (datos === -1) {
      return {
        code: 10,
        data: "",
        message: mensajeerrorconexion()
      };
    }

    if (typeof datos === "object" && datos !== null) {
      return {
        code: Number(datos.code ?? 99),
        data: datos.data ?? "",
        message: datos.message || "Respuesta inválida del servidor"
      };
    }

    const raw = String(datos || "").trim();

    if (!raw) {
      return {
        code: 99,
        data: "",
        message: "No se recibió contenido PDF"
      };
    }

    if (raw.startsWith("{") || raw.startsWith("[")) {
      try {
        const parsed = JSON.parse(raw);
        return {
          code: Number(parsed.code ?? 99),
          data: parsed.data ?? "",
          message: parsed.message || "Respuesta inválida del servidor"
        };
      } catch (e) {
        return {
          code: 99,
          data: "",
          message: "La respuesta no es un JSON válido"
        };
      }
    }

    // si por alguna razón regresan base64 plano
    return {
      code: 0,
      data: raw,
      message: "PDF generado correctamente"
    };
  } catch (error) {
    return {
      code: 10,
      data: "",
      message: mensajeerrorconexion()
    };
  }
}

//////////////////////////////////////////////////////////////////////////
export async function eliminarSolicitud(idsolicitudfactura) {
  //idproducto = "idsolicitudfactura:"+idproducto;

  var resp = [];
  try {

    var datos = await consumir_api(apigeneral + "api/solicitud/eliminar/" + idsolicitudfactura, [], "delete", "")

    if (datos === -1) {
      //console.log("Datos Generales --- ")
      resp.push({
        code: 10,
        message: mensajeerrorconexion()
      })
    }

    else if (datos.code === 0) {
      var temporal = datos.data;

      resp.push({
        code: 0,
        data: temporal,
        message: datos.message
      })

    }
    else if (datos.code === 2) {
      resp.push({ code: 2, data: [], message: datos.message })
    }
    else {
      resp.push({ code: datos.code, data: [], message: datos.message })
    }


  } catch (error) {
    // console.log("sin conexion");
    resp.push({
      code: 10,
      message: mensajeerrorconexion()
    })
  }
  return resp[0];
}
///////////////////////////////////////////////////////////////////////////////////////////////////
export async function agregarusuario(json) {


  var resp = [];

  try {

    var datos = await consumir_api(apigeneral + "api/catalogo/usuarios", json, "post", "")

    if (datos === -1) {
      //console.log("Datos Generales --- ")
      resp.push({
        code: 10,
        message: mensajeerrorconexion()
      })
    }

    else if (datos.code === 0) {
      var temporal = datos.data;

      resp.push({
        code: 0,
        data: temporal,
        message: datos.message
      })

    }
    else if (datos.code === 2) {
      resp.push({ code: 2, data: [], message: datos.message })
    }
    else {
      resp.push({ code: datos.code, data: [], message: datos.message })
    }


  } catch (error) {
    // console.log("sin conexion");
    resp.push({
      code: 10,
      message: mensajeerrorconexion()
    })
  }
  return resp[0];
}
/////////////////////////////////////////////////////////////////////////////////////////////////

export async function editarUsuario(idproducto, json) {

  var resp = [];
  try {

    var datos = await consumir_api(apigeneral + "api/catalogo/usuarios/" + idproducto, json, "put", "")

    if (datos === -1) {
      //console.log("Datos Generales --- ")
      resp.push({
        code: 10,
        message: mensajeerrorconexion()
      })
    }

    else if (datos.code === 0) {
      var temporal = datos.data;

      resp.push({
        code: 0,
        data: temporal,
        message: datos.message
      })

    }
    else if (datos.code === 2) {
      resp.push({ code: 2, data: [], message: datos.message })
    }
    else {
      resp.push({ code: datos.code, data: [], message: datos.message })
    }


  } catch (error) {
    // console.log("sin conexion");
    resp.push({
      code: 10,
      message: mensajeerrorconexion()
    })
  }
  return resp[0];
}
/////////////////////////////////////////////////////////////////////////////////////////////////
export async function cambiarContrasenaUsuario(json) {

  var resp = [];
  try {

    var datos = await consumir_api(apigeneral + "api/catalogo/usuarios/cambiar-password", json, "post", "")

    if (datos === -1) {
      //console.log("Datos Generales --- ")
      resp.push({
        code: 10,
        message: mensajeerrorconexion()
      })
    }

    else if (datos.code === 0) {
      var temporal = datos.data;

      resp.push({
        code: 0,
        data: temporal,
        message: datos.message
      })

    }
    else if (datos.code === 2) {
      resp.push({ code: 2, data: [], message: datos.message })
    }
    else {
      resp.push({ code: datos.code, data: [], message: datos.message })
    }


  } catch (error) {
    // console.log("sin conexion");
    resp.push({
      code: 10,
      message: mensajeerrorconexion()
    })
  }
  return resp[0];
}
//////////////////////////////////////////////////////////////////////////////////////////////////

export async function resetContrasenaUsuario(json) {


  var resp = [];

  try {

    var datos = await consumir_api(apigeneral + "api/catalogo/usuarios/recuperar-password", json, "post", "recuperarPass")

    if (datos === -1) {
      //console.log("Datos Generales --- ")
      resp.push({
        code: 10,
        message: mensajeerrorconexion()
      })
    }

    else if (datos.code === 0) {
      var temporal = datos.data;

      resp.push({
        code: 0,
        data: temporal,
        message: datos.message
      })

    }
    else if (datos.code === 2) {
      resp.push({ code: 2, data: [], message: datos.message })
    }
    else {
      resp.push({ code: datos.code, data: [], message: datos.message })
    }


  } catch (error) {
    // console.log("sin conexion");
    resp.push({
      code: 10,
      message: mensajeerrorconexion()
    })
  }
  return resp[0];
}
// importar Ventas

export async function importarVentasExcel(file) {
  const resp = [];

  try {
    const form = new FormData();
    form.append("file", file);

    const datos = await consumir_api(
      apigeneral + "api/archivo/importar-ventas-concentrado",
      form,
      "post",
      null,
      true
    );

    if (datos === -1) {
      resp.push({ code: 1000, message: "Error de conexión, revisa tu conexión a internet" });
      return resp[0];
    }

    if (datos.code === 0) {
      resp.push({ code: 0, message: "Ventas importadas correctamente", data: datos.data || [] });

    } else {
      resp.push({ code: datos.code ?? 1, message: datos.message || "Error", data: [] });
    }
  } catch (error) {
    resp.push({ code: 1000, message: "Error de conexión, revisa tu conexión a internet" });
  }

  return resp[0];
}

//////////////////////////////////////////////////////////////////////////////////////////////////////
export async function importarProductosExcel(file) {
  const resp = [];

  try {
    const form = new FormData();
    form.append("file", file);

    const datos = await consumir_api(
      apigeneral + "api/archivo/importar-ventas-productos",
      form,
      "post",
      null,
      true
    );

    if (datos === -1) {
      resp.push({ code: 1000, message: "Error de conexión, revisa tu conexión a internet" });
      return resp[0];
    }

    if (datos.code === 0) {
      resp.push({ code: 0, message: "Productos importados correctamente", data: datos.data || [] });
    } else {
      resp.push({ code: datos.code ?? 1, message: datos.message || "Error", data: [] });
    }
  } catch (error) {
    resp.push({ code: 1000, message: "Error de conexión, revisa tu conexión a internet" });
  }

  return resp[0];
}
//////////////////////////////////////////////////////////////////////////////////////////////////////

export async function importSantanderExcel(file) {
  const resp = [];

  try {
    const form = new FormData();
    form.append("file", file);

    const datos = await consumir_api(
      apigeneral + "api/archivo/importar-ventas-santander",
      form,
      "post",
      null,
      true
    );

    if (datos === -1) {
      resp.push({ code: 1000, message: "Error de conexión, revisa tu conexión a internet" });
      return resp[0];
    }

    if (datos.code === 0) {
      resp.push({ code: 0, message: "Importación realizada correctamente", data: datos.data || [] });
    } else {
      resp.push({ code: datos.code ?? 1, message: datos.message || "Error", data: [] });
    }
  } catch (error) {
    resp.push({ code: 1000, message: "Error de conexión, revisa tu conexión a internet" });
  }

  return resp[0];
}
